import { colors, sizes } from '@lmc/common/constants'
import dayjs from 'dayjs'
import _ from 'lodash'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { isBrowser, isTablet } from 'react-device-detect'
import { connect } from 'react-redux'
import {
  DashboardListItem,
  HeaderSection,
  ListItem,
  Spinner
} from '../../../../components/generic'
import { Col, Row } from '../../../../LEGACY/elemental'
import Operations from '../../../../operations'
import { withRouter } from '../../../../withRouter'

const isDesktop = isBrowser || isTablet

export function HomeDashboard(props) {
  const {
    bmi,
    carePlans,
    fetchData,
    home,
    incidents,
    isLoading,
    router: { params },
    todos
  } = props

  useEffect(() => {
    fetchData(params.id)
  }, [params.id])

  if (!home || isLoading || !todos || !carePlans || !incidents || !bmi) {
    return <Spinner />
  }

  return (
    <div style={styles.container}>
      <Row>
        <Col xs="100%" sm="50%" md="50%" lg="50%" gutter={36}>
          <div style={{ paddingTop: '0px' }}>
            <div style={{ paddingBottom: 20 }}>
              <HeaderSection title="Team" />
            </div>
            <div style={styles.teamSection}>
              <div style={styles.heading}>Care Plans</div>
              <DashboardListItem
                iconName={'tick-in-circle'}
                iconFill={colors.purple}
                text={`due over 3 months away`}
                count={carePlans.later || 0}
              />
              <DashboardListItem
                iconName={'tick-in-circle'}
                iconFill={colors.darkblue}
                text={`due in the next 3 months`}
                count={carePlans.threeMonths || 0}
              />
              <DashboardListItem
                iconName={'tick-in-circle'}
                iconFill={colors.turquoise}
                text={`due this month`}
                count={carePlans.month || 0}
              />
              <DashboardListItem
                iconName={'clock'}
                iconFill={colors.orange}
                text={`due this week`}
                count={carePlans.week || 0}
              />
              <DashboardListItem
                iconName={'overdue'}
                iconFill={colors.red}
                text={`overdue`}
                count={carePlans.overdue || 0}
              />
            </div>
            <div style={styles.teamSection}>
              <div style={styles.heading}>Today's To-Do's</div>
              <DashboardListItem
                iconName={'tick-in-circle'}
                iconFill={colors.green}
                text={`completed`}
                count={todos.completed}
              />
              <DashboardListItem
                iconName={'skip'}
                iconFill={colors.blue}
                text={`skipped`}
                count={todos.skipped}
              />
              <DashboardListItem
                iconName={'clock'}
                iconFill={colors.orange}
                text={`pending`}
                count={todos.pending}
              />
              <DashboardListItem
                iconName={'overdue'}
                iconFill={colors.red}
                text={`overdue`}
                count={todos.overdue}
              />
            </div>
          </div>
        </Col>
        <Col xs="100%" sm="50%" md="50%" lg="50%" gutter={36}>
          <HeaderSection title="Residents" />
          <ListItem
            label={'BMI'}
            iconText="BMI"
            hasSubList={true}
            borderRadius={4}
            // childrenStyles={{ paddingTop: 10, paddingLeft: 24 }}
            to={`/homes/${params.id}/bmi`}
          >
            <div style={styles.bmiContainer}>
              <DashboardListItem
                iconName={'roundedSquare'}
                iconFill={colors.green}
                iconSize={16}
                iconViewBox={'0 0 16 16'}
                iconMarginTop={2}
                iconMarginRight={16}
                text={`healthy`}
                count={bmi.healthy || 0}
              />
              <DashboardListItem
                iconName={'roundedSquare'}
                iconFill={colors.blue}
                iconSize={16}
                iconViewBox={'0 0 16 16'}
                iconMarginTop={2}
                iconMarginRight={16}
                text={`underweight`}
                count={bmi.underweight || 0}
              />
              <DashboardListItem
                iconName={'roundedSquare'}
                iconFill={colors.yellow}
                iconSize={16}
                iconViewBox={'0 0 16 16'}
                iconMarginTop={2}
                iconMarginRight={16}
                text={`overweight`}
                count={bmi.overweight || 0}
              />
              <DashboardListItem
                iconName={'roundedSquare'}
                iconFill={colors.orange}
                iconSize={16}
                iconViewBox={'0 0 16 16'}
                iconMarginTop={2}
                iconMarginRight={16}
                text={`obese`}
                count={bmi.obese || 0}
              />
              <DashboardListItem
                iconName={'roundedSquare'}
                iconFill={colors.red}
                iconSize={16}
                iconViewBox={'0 0 16 16'}
                iconMarginTop={2}
                iconMarginRight={16}
                text={`extremely obese`}
                count={bmi.extremelyObese || 0}
              />
            </div>
          </ListItem>
          <ListItem
            label={'Incidents'}
            iconColor={colors.red}
            icon="https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/W-iMGACw_TjNMEhv.png"
            borderRadius={30}
            text={`${incidents.count} incidents today`}
            to={`/homes/${params.id}/incidents`}
          />
        </Col>
      </Row>
    </div>
  )
}

const styles = {
  button: {
    background: colors.green,
    color: 'white',
    padding: '0px 25px',
    marginLeft: 10,
    textShadow: 'none'
  },
  container: {
    margin: '0 auto',
    maxWidth: sizes.childScreen,
    paddingBottom: 90,
    paddingTop: 36
  },
  footer: {
    border: 'none',
    background: 'white',
    display: 'flex',
    justifyContent: isDesktop ? 'flex-end' : 'space-between'
  },
  heading: {
    fontWeight: 'bold',
    fontSize: 16,
    paddingBottom: 10
  },
  listItem: {
    height: 30,
    lineHeight: '30px',
    verticalAlign: 'middle'
  },
  teamSection: {
    paddingBottom: 30
  },
  text: {
    fontSize: 14,
    verticalAlign: 'middle'
  },
  bmiContainer: {
    marginTop: 12
  }
}

HomeDashboard.propTypes = {
  home: PropTypes.object
}

const TODOS_REQUREST = 'group_site_todos'
const CARE_PLAN_REQUREST = 'group_site_care_plans'
const BMI_REQUREST = 'group_bmi_plans'
const INCIDENT_REQUREST = 'group_incident_counts'
const mapStateToProps = (state, props) => {
  const { id } = props.router.params
  return {
    home: _.find(state.data.homes, { id }),
    todos: _.get(state, `data.requests.${TODOS_REQUREST}.response`),
    carePlans: _.get(state, `data.requests.${CARE_PLAN_REQUREST}.response`),
    incidents: _.get(state, `data.requests.${INCIDENT_REQUREST}.response`),
    bmi: _.get(state, `data.requests.${BMI_REQUREST}.response`),
    isLoading:
      _.get(state, `data.requests.${TODOS_REQUREST}.isLoading`) ||
      _.get(state, `data.requests.${CARE_PLAN_REQUREST}.isLoading`) ||
      _.get(state, `data.requests.${INCIDENT_REQUREST}.isLoading`) ||
      _.get(state, `data.requests.${BMI_REQUREST}.isLoading`),
    error: _.get(state, `data.requests.${TODOS_REQUREST}.error`)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchData: (home) => {
      dispatch(
        Operations.fetchData({
          url: `/aggregations/todos`,
          query: { home },
          id: TODOS_REQUREST
        })
      )
      dispatch(
        Operations.fetchData({
          url: `/aggregations/care-plans`,
          query: { home },
          id: CARE_PLAN_REQUREST
        })
      )
      dispatch(
        Operations.fetchData({
          url: `/aggregations/bmi`,
          query: { home },
          id: BMI_REQUREST
        })
      )
      dispatch(
        Operations.fetchData({
          url: `aggregations/incidents`,
          query: {
            home,
            total: 1,
            from: dayjs().startOf('day').toISOString()
          },
          id: INCIDENT_REQUREST
        })
      )
    }
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(HomeDashboard)
)
